module.exports = __webpack_public_path__ + "static/media/merchant_cash_voucher.05181e19.png";